
import { Button, Col, Form, Input, notification, Popconfirm, Row, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
import { addFocusHealthAreaApi, listOfFocusHealthAreaApi, updateFocusHealthAreaApi } from "../../../../../config/Api";
export const FocusHealthAreas = () => {

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [focusHealthAreassData, setFocusHealthAreassData] = useState()
    const [editFocusHealthAreasRecord, setEditFocusHealthAreasRecord] = useState()
    const [loading, setLoading] = useState(false)

    const [form] = Form.useForm();

    // get the list of all Focus Health Areas
    const getListOfFocusHealthAreas = () => {
        setLoading(true)

        listOfFocusHealthAreaApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // call when user click on edit
    const editFocusHealthArea = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'name': data.name })
        setEditFocusHealthAreasRecord(data);
    }

    useEffect(() => {
        getListOfFocusHealthAreas()
    }, []);

    // filter data according to user search input 
    useEffect(() => {
        filterFocusHealthAreas(focusHealthAreassData);
    }, [focusHealthAreassData]);

    // filter recipe category
    const filterFocusHealthAreas = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of recipe category
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateFocusHealthAreaApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Focus Health Areas Update successfully",
                    });
                    getListOfFocusHealthAreas()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.name,
                "status": true
            }
            addFocusHealthAreaApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'name': '' })
                        notification.success({
                            message: "Focus Health Areas added successfully",
                        });
                        getListOfFocusHealthAreas()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.name,
                "status": values.status
            }
            updateFocusHealthAreaApi(editFocusHealthAreasRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Focus Health Areas Update successfully",
                        });
                        getListOfFocusHealthAreas()
                        form.setFieldsValue({ 'name': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editFocusHealthArea(record) }} className="me-2" />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            name: 'Acidity',
            status: true
        },
        {
            id: '2',
            name: 'Anxiety',
            status: false
        },
        {
            id: '3',
            name: 'Brain Tumour',
            status: true
        },
        {
            id: '4',
            name: 'Chickenpox',
            status: true
        },
        {
            id: '5',
            name: 'Cholera',
            status: true
        }
    ];

    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="Diseases">
            <Row>
                <Col xl={14}>
                    <Form
                        name="addDiseasesForm"
                        // className="addDiseasesForm"
                        form={form}
                    onFinish={onFinish}
                    >
                        <Row className="addDiseasesForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Focus Health Areas!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter Focus Health Area Name" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={8}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2" icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}
                                >
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>

                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    <h6>Total : {displayData.length > 0 ? displayData.length : 0}  </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Focus Health Areas"
                        onChange={(e) => { filterFocusHealthAreas(e.target.value); setFocusHealthAreassData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
            <Row>
                <Table
                    columns={columns}
                    rowKey="id"
                    dataSource={displayData}
                    // pagination={false}
                    scroll={{ x: "max-content" }}
                    className="w-100"
                />
            </Row>
            </Spin>
        </div>
    )
}
